import { Rule } from 'antd/lib/form';

export const searchEventFormRules = {
    title: (): Rule[] => [{ max: 255 }],
    city: (): Rule[] => [{ max: 127 }],
    distance: (): Rule[] => [{ min: 0 }]
}